import React from 'react';
import Media from './Media';
import Abstract from './Abstract';
import Keywords from './Keywords';
import FindThisPaper from './FindThisPaper/FindThisPaper';
import AuthorsList from './AuthorsList/AuthorsListContainer';
import Citations from './Citations';
import Suggestions from './Suggestions';

const track = { context: 'Document' };

export default function Overview({ doc, doc: { abstract, keywords = [] } }) {
  const abstractCard = <Abstract abstract={abstract} />;
  const keywordsCard = <Keywords title="Author-supplied keywords" words={keywords} />;
  const findThisPaper = <FindThisPaper doc={doc} />;
  const citations = <Citations doc={doc} track={track} />;
  const authors = <AuthorsList doc={doc} track={track} title="Authors" max={6} />;
  const suggestions = <Suggestions doc={doc} track={track} />;

  return (
    <div className="row">
      <Media min="m">
        <div className="column d-2-3">
          { abstractCard }
          { keywordsCard }
          { suggestions }
          { citations }
        </div>
        <div className="column d-1-3">
          { findThisPaper }
          { authors }
        </div>
      </Media>
      <Media max="m">
        <div className="column">
          { abstractCard }
          { keywordsCard }
          { suggestions }
          { findThisPaper }
          { authors }
          { citations }
        </div>
      </Media>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Overview.js